import { render, staticRenderFns } from "./ContactActivities.vue?vue&type=template&id=254522b2&scoped=true"
import script from "./ContactActivities.vue?vue&type=script&lang=js"
export * from "./ContactActivities.vue?vue&type=script&lang=js"
import style0 from "./ContactActivities.vue?vue&type=style&index=0&id=254522b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254522b2",
  null
  
)

export default component.exports